import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { TransactionMode, } from '@tencent/memoire-core';
import { KeyUtils } from './utils/key-utils';
var NativeEngineCursor = /** @class */ (function () {
    function NativeEngineCursor(values, table, direction, mode, engineAspects) {
        var _a;
        this.direction = direction;
        this.mode = mode;
        this.engineAspects = engineAspects;
        this.delete = undefined;
        this.update = undefined;
        this.cursor = 0;
        this.engineTable = table;
        this.values = this.preProcessedData(values);
        if (!this.isPositiveDirection()) {
            this.cursor = this.values.length - 1;
        }
        if (mode !== TransactionMode.READ_ONLY) {
            this.delete = this.deleteData;
            this.update = this.updateData;
        }
        if ((_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.cursor) {
            this.applyAspectPatch();
        }
    }
    NativeEngineCursor.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newCursor;
            return __generator(this, function (_a) {
                newCursor = this.cursor + (this.isPositiveDirection() ? 1 : -1);
                if (newCursor < 0 || newCursor > this.values.length - 1) {
                    return [2 /*return*/, null];
                }
                this.cursor = newCursor;
                return [2 /*return*/, this];
            });
        });
    };
    NativeEngineCursor.prototype.value = function () {
        return this.values[this.cursor];
    };
    NativeEngineCursor.prototype[Symbol.asyncIterator] = function () {
        return new NativeCursorIterator(this);
    };
    NativeEngineCursor.prototype.deleteData = function () {
        var key = KeyUtils.getKeyFromValue(this.value(), this.engineTable.keyPath);
        return this.engineTable.delete(key);
    };
    NativeEngineCursor.prototype.updateData = function (data) {
        return this.engineTable.upsert(data);
    };
    NativeEngineCursor.prototype.isPositiveDirection = function () {
        return this.direction === 'next' || this.direction === 'nextunique';
    };
    NativeEngineCursor.prototype.isUniqueDirection = function () {
        return this.direction === 'nextunique' || this.direction === 'prevunique';
    };
    NativeEngineCursor.prototype.preProcessedData = function (values) {
        if (this.isUniqueDirection()) {
            return __spreadArray([], __read(new Set(values)));
        }
        return values;
    };
    /**
     * bind the hook stub to the cursor object
     */
    NativeEngineCursor.prototype.applyAspectPatch = function () {
        var _a;
        var cursorAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.cursor;
        if (this.mode !== TransactionMode.READ_ONLY) {
            var readWriteCursor = this;
            cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.delete.patch(readWriteCursor, 'delete');
            cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.update.patch(readWriteCursor, 'update');
        }
        cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.next.patch(this, 'next');
        cursorAspects === null || cursorAspects === void 0 ? void 0 : cursorAspects.value.patch(this, 'value');
    };
    return NativeEngineCursor;
}());
export { NativeEngineCursor };
var NativeCursorIterator = /** @class */ (function () {
    function NativeCursorIterator(currentCursor) {
        this.currentCursor = currentCursor;
    }
    NativeCursorIterator.prototype[Symbol.asyncIterator] = function () {
        return this;
    };
    NativeCursorIterator.prototype.next = function () {
        return __awaiter(this, void 0, void 0, function () {
            var value, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.currentCursor) {
                            return [2 /*return*/, { value: undefined, done: true }];
                        }
                        value = this.currentCursor.value();
                        _a = this;
                        return [4 /*yield*/, this.currentCursor.next()];
                    case 1:
                        _a.currentCursor = _b.sent();
                        return [2 /*return*/, { value: value, done: false }];
                }
            });
        });
    };
    return NativeCursorIterator;
}());
//# sourceMappingURL=cursor.js.map